import { render, staticRenderFns } from "./password-validation.vue?vue&type=template&id=58868e08"
import script from "./password-validation.vue?vue&type=script&lang=js"
export * from "./password-validation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports